import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';
import { Order } from '~/@types/table/order';
import { ASC_SORTED_COLUMNS } from '~/constants/columns';

export type SortProps = {
  order: Order;
  orderBy: string;
  sortField: string;
  createSortHandler(property: string): (event: React.MouseEvent<unknown>) => void;
};

type Args = {
  orderField?: string;
  customOrder?: Order;
  resetPage?: () => void;
};

const useSort = (args?: Args) => {
  const router = useRouter();
  const { orderField: savedOrderBy, order: savedOrder } = router.query;

  const [order, setOrder] = useState<Order>((savedOrder as Order) || args?.customOrder || 'asc');
  const [orderBy, setOrderBy] = useState<string>(
    (savedOrderBy as string) || args?.orderField || ''
  );

  const sortField = useMemo(() => {
    switch (orderBy) {
      case undefined:
        return '';
      case 'name':
        return 'last_name';
      case 'team_lead':
        return 'last_name';
      case 'team_name':
        return 'agent_team';
      case 'organization_type':
        return 'company_type';
      default:
        return orderBy;
    }
  }, [orderBy]);

  const newOrder = (property: string) => {
    if (orderBy === property) {
      return order === 'asc' ? 'desc' : 'asc';
    } else {
      return ASC_SORTED_COLUMNS.includes(property) ? 'asc' : 'desc';
    }
  };

  const handleRequestSort = (_event: React.MouseEvent<unknown>, property: string) => {
    args && args.resetPage && args.resetPage();
    setOrder(newOrder(property));
    setOrderBy(property);
  };

  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    handleRequestSort(event, property);
  };

  return {
    order,
    orderBy,
    sortField,
    createSortHandler,
  };
};

export default useSort;
